const _version = "2.11.2"
function version() {
    return _version
}
export default version
